import axios from 'axios';
import API_HOST from '../api';

const mapInspectApi = function() {
  const api = {};

  api.inspectLocation = function(inspectionArea, layers, clientId, userId) {
    let url = `${API_HOST}/api/client/${clientId}`;
    if (typeof userId !== 'undefined') {
      url += `/user/${userId}`;
    }

    url += '/map-inspect';


    return axios.post(url, {
      inspectionArea,
      layers,
    });
  };

  return api;
};

export default mapInspectApi(API_HOST, axios);
